import React, { useState, useRef, useLayoutEffect, useEffect } from "react";
import "./TauriSidebarFilter.css";
import { Dropdown } from "react-bootstrap";
import TauriImage from "../../../TauriImage/TauriImage";
import OpalSearchSuggestion from "./OpalSearchSuggestion/OpalSearchSuggestion";
import { createPortal } from "react-dom";
import { Form } from "react-bootstrap";


const groupByOptions = [
    { key: false, label: "No Grouping" },
    { key: "InstitutionName", label: "Institutions" },
    { key: "Area", label: "Area/Territory" },
    { key: "Specialty", label: "Classifications" }
];

const orderByOptionss = [
    { key: "Time_Start", label: "Best Time to Visit" },
    { key: "Area", label: "Area/Territory" }
];

const sessionByOptions = [
    { key: true, label: "Show" },
    { key: false, label: "Hide" }
];

const TauriSidebarFilter = ({ searchTerm, setSearchTerm, setSelectedDate, setSelectedFilter, setIsSidebarCollapsed }) => {
    const [showSuggestion, setShowSuggestion] = useState(false);
    const [showMenu, setShowMenu] = useState(false);
    const [inputRect, setInputRect] = useState(null);

    const [selectedGroupBy, setSelectedGroupBy] = useState(groupByOptions[0]);
    const [showFinishedSession, setShowFinishedSession] = useState(sessionByOptions[0]);
    const [selectedOrderBy, setSelectedOrderBy] = useState(orderByOptionss[0]);

    const inputRef = useRef();

    const menuRef = useRef();

    useLayoutEffect(() => {
        if (showSuggestion && inputRef.current) {
            const rect = inputRef.current.getBoundingClientRect();
            setInputRect({
                top: rect.bottom + window.scrollY,
                left: rect.left + window.scrollX,
                width: rect.width
            });
        }
    }, [showSuggestion]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setShowMenu(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    useEffect(() => {
        setSelectedFilter(
            {
                orderby: selectedOrderBy?.key,
                groupby: selectedGroupBy?.key,
                show: showFinishedSession?.key
            })
        setShowMenu(false);
    }, [selectedGroupBy, showFinishedSession, selectedOrderBy])

    return (
        <>
            <div className="tauri-sidebar-filter">
                {/* Search Input */}
                <div className="tauri-sidebar-search d-flex align-items-center justify-content-center w-100 pt-2 px-1">
                    <div className="input-group">
                        <input
                            type="text"
                            ref={inputRef}
                            className="form-control"
                            placeholder="Search"
                            autoComplete="new-password"
                            value={searchTerm}
                            onMouseDown={() => setShowSuggestion(true)}
                            onChange={(e) => {
                                const value = e.target.value;
                                setSearchTerm(value);
                                setShowSuggestion(value.length >= 3);
                            }}
                        />
                    </div>
                    <div ref={menuRef} style={{ position: "relative" }}>
                        <TauriImage
                            localImage={"/Images/akar-icons--settings-horizontal.svg"}
                            onClick={() => setShowMenu((prev) => !prev)}
                            alt="icon"
                            style={{ cursor: "pointer" }}
                        />
                        {showMenu && (
                            <div
                                className="opal-settings-menu"
                                style={{
                                    position: "absolute",
                                    top: "100%",
                                    right: 0,
                                    width: "17rem",
                                    backgroundColor: "#fff",
                                    border: "1px solid #B8CCE2",
                                    borderRadius: "0.25rem",
                                    zIndex: 10,
                                    marginTop: "0.25rem",
                                    padding: "0.5rem",
                                    fontSize: "0.8rem"
                                }}
                            >
                                <div className="row align-items-center mb-2">
                                    <div className="col-5 text-nowrap">Group By :</div>
                                    <div className="col-7">
                                        <Dropdown>
                                            <Dropdown.Toggle className="form-control text-start">
                                                {selectedGroupBy?.label}
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu>
                                                {groupByOptions.map((item) => (
                                                    <Dropdown.Item key={item.key} onClick={() => setSelectedGroupBy(item)}>
                                                        {item.label}
                                                    </Dropdown.Item>
                                                ))}
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div>
                                </div>

                                {/* Finished Sessions */}
                                <div className="row align-items-center mb-2">
                                    <div className="col-5 text-nowrap">Finished Sessions :</div>
                                    <div className="col-7">
                                        <Dropdown>
                                            <Dropdown.Toggle className="form-control text-start">
                                                {showFinishedSession?.label}
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu>
                                                {sessionByOptions.map((item) => (
                                                    <Dropdown.Item key={item.key} onClick={() => setShowFinishedSession(item)}>
                                                        {item.label}
                                                    </Dropdown.Item>
                                                ))}
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div>
                                </div>

                                {/* Order By */}
                                <div className="row align-items-center">
                                    <div className="col-5 text-nowrap">Order By :</div>
                                    <div className="col-7">
                                        <Dropdown>
                                            <Dropdown.Toggle className="form-control text-start">
                                                {selectedOrderBy?.label}
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu>
                                                {orderByOptionss.map((item) => (
                                                    <Dropdown.Item key={item.key} onClick={() => setSelectedOrderBy(item)}>
                                                        {item.label}
                                                    </Dropdown.Item>
                                                ))}
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {/* Suggestion rendered via portal */}
            {showSuggestion && inputRect &&
                createPortal(
                    <div
                        style={{
                            position: "absolute",
                            top: inputRect.top + 3,
                            left: inputRect.left,
                            width: inputRect.width,
                            zIndex: 5
                        }}
                    >
                        <OpalSearchSuggestion
                            show={showSuggestion}
                            setShowSuggestion={setShowSuggestion}
                            setSelectedDate={setSelectedDate}
                            search={searchTerm}
                            setSearch={setSearchTerm}
                        />
                    </div>,
                    document.body
                )
            }
        </>
    );
};

export default TauriSidebarFilter;
